import { render, staticRenderFns } from "./ThePersonalization.vue?vue&type=template&id=c09501f0&"
import script from "./ThePersonalization.vue?vue&type=script&lang=js&"
export * from "./ThePersonalization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports